import { extractImageFrames, clampTo } from '../../tools';
import type { openrouterModelConfig } from '../types';


export const xaiConfigs: Record<string, openrouterModelConfig> = {
    'grok-imagine-video': {
        // https://openrouter.ai/x-ai/grok-imagine-video/api
        apiPath: '/api/v1/videos',
        pollApiPath: '/api/v1/videos/{id}',
        statusMapping: {
            taskIdPath: 'id',
            success: ['completed'],
            failed: ['failed', 'cancelled', 'expired'],
            processing: ['pending', 'in_progress'],
            statePath: 'status',
            videoUrlPath: 'unsigned_urls[0]',
            errorPath: 'error',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, imagePrompt, duration, aspectRatio, quality, modelUi } = params;
            const frameMode = modelUi?.frameMode;
            const [firstImage] = extractImageFrames(imagePrompt);
            // 首帧模式
            if (frameMode === 'first') {
                return {
                    model: 'x-ai/grok-imagine-video',
                    prompt: prompt.slice(0, 2000),
                    duration: clampTo(duration || 5, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                    // 首帧 URL
                    frame_images: [
                        {
                            type: 'image_url',
                            image_url: {
                                url: firstImage,
                            },
                            frame_type: 'first_frame',
                        }
                    ],
                }
            // 参考模式
            } else if (frameMode === 'ref') {
                return {
                    model: 'x-ai/grok-imagine-video',
                    prompt: prompt.slice(0, 2000),
                    duration: clampTo(duration || 5, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10] as const, 5),
                    resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                    // 参考图 URL
                    input_references: (imagePrompt ?? []).slice(0, 7).map((url) => ({
                        type: 'image_url',
                        image_url: {
                            url,
                        },
                    })),
                }
            // 文生视频模式
            } else {
                return {
                    model: 'x-ai/grok-imagine-video',
                    prompt: prompt.slice(0, 2000),
                    aspect_ratio: clampTo(aspectRatio || '16:9', ['16:9', '9:16', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                    duration: clampTo(duration || 5, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15] as const, 5),
                    resolution: clampTo(quality || '720p', ['480p', '720p'] as const, '720p'),
                };
            }
        } 
    },
};